import { PROPERTY_OBJECT_TYPE_IDS } from '../constants';
const collator = new Intl.Collator(undefined, {
  sensitivity: 'base'
});
const sortOptionsByAlphabet = arrayForSorted => {
  return [...arrayForSorted].sort((a, b) => collator.compare(a.text, b.text));
};
const getUniqueOptionsByValue = arrayOptions => {
  const uniqueValues = [];
  return [...arrayOptions].reduce((acc, option) => {
    if (!uniqueValues.includes(option.value)) {
      uniqueValues.push(option.value);
      acc.push(option);
    }
    return acc;
  }, []);
};
export const getOptions = webinars => {
  return webinars.map(webinar => {
    return {
      value: webinar.id,
      text: webinar.name
    };
  });
};
export const getUniqueAndSortedOptions = arrayOptions => {
  return sortOptionsByAlphabet(getUniqueOptionsByValue(arrayOptions));
};
export const defaultRequiredProperty = [{
  objectTypeId: PROPERTY_OBJECT_TYPE_IDS.CONTACT,
  propertyName: 'firstname'
}, {
  objectTypeId: PROPERTY_OBJECT_TYPE_IDS.CONTACT,
  propertyName: 'lastname'
}, {
  objectTypeId: PROPERTY_OBJECT_TYPE_IDS.CONTACT,
  propertyName: 'email'
}];

// window.location.pathname - "/pages/{portalId}/editor/{contentId}/content"
export const getContentId = () => {
  const pathname = window.location.pathname.replace('editor/', ':');
  return pathname.slice(pathname.indexOf(':') + 1, pathname.lastIndexOf('/'));
};
export const getAppStatusByWebinarSource = (webinarSource, appStatus) => {
  return webinarSource ? appStatus.find(status => {
    return status.appId.toString() === webinarSource;
  }) : undefined;
};